export const createLanguageName = (language: string) => {
  switch (language) {
    case 'ru':
      return 'RU'
    case 'en':
      return 'EN'
    default:
      return 'EN'
  }
}
